export type LabelValue<V = string> = { value: V; label: string }

type ToLabel<V = string> = (input: V) => string

export const toLabelValue = <V = string>(value: V, toLabel: ToLabel<V> = (value) => `${value}`): LabelValue<V> => ({
  value,
  label: toLabel(value),
})

export const getSelectedLabelValues = (selectedValues: string[], labelValues: LabelValue[]) =>
  selectedValues.map((value) => ({ value, label: labelValues.find((option) => option.value === value)?.label ?? '' }))
